import(/* webpackMode: "eager", webpackExports: ["SWRConfig"] */ "/opt/build/repo/app/_providers/SWRConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/Converter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlagProvider"] */ "/opt/build/repo/hooks/useFeatureFlags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/opt/build/repo/node_modules/swr/dist/index/config-client-Bi4rgVRk.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ConverterPageProvider"] */ "/opt/build/repo/utils/converter-provider.tsx");
